import { Clock, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function VisitUsInHalmstad() {
  return <section data-section-id="181284" id="välkommen-att-ta-kontakt" className="bg-background text-foreground w-full border-t border-border/20 relative overflow-hidden opacity-40 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/image_n8h5vl42.png)]">
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/image_n8h5vl42.png)] z-0 opacity-40 [filter:opacity(0.4)]" />
      <div className="min-h-[800px] relative z-10 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/image_n8h5vl42.png)]">
        {}
        <div className="flex flex-col justify-center z-10 relative !w-[714px] !items-start ![margin:0px_60px_0px_60px] ![padding:20px_0px_0px_40px]">
          {}

          <h2 className="font-sans tracking-tight font-bold !text-5xl ![margin:0px_0px_50px_0px] ![padding:40px_0px_0px_0px]">Välkommen att <span className="text-[rgb(214,67,72)]">ta kontakt</span>&nbsp;</h2>

          <div className="space-y-12 relative z-10 -translate-y-[20%] !w-[714px]">
            {}
            <div className="group">
              
            </div>

            {}
            <div className="group">
              
              <span className="flex items-center gap-3 text-accent font-sans uppercase tracking-[0.2em] text-xs !font-bold ![margin:0px_0px_12px_0px]">SVARSTID & TILLGÄNGLIGHET</span>
              <ul className="text-lg md:text-xl text-muted-foreground space-y-3 font-sans font-light max-w-sm">
                <li className="flex justify-between items-center border-b border-border/30 pb-2 group-hover:text-primary transition-colors duration-300 !m-0">
                  <span>E-post</span>
                  <span className="text-primary font-medium">info@logikekonimi.se</span>
                </li>
                <li className="flex justify-between items-center border-b border-border/30 pb-2 group-hover:text-primary transition-colors duration-300 !m-0">
                  <span>Telefon</span>
                  <span className="text-primary font-medium">+46 73 655 09 11</span>
                </li>
                <li className="flex justify-between items-center border-b border-border/30 pb-2 group-hover:text-primary transition-colors duration-300 !m-0">
                  <span>Svarstid</span>
                  <span className="text-primary font-medium">08.30 - 16.30</span>
                </li>
                <li className="flex justify-between items-center group-hover:text-primary transition-colors duration-300 !p-0 !m-0">
                  <span>Helger</span>
                  <span className="text-accent italic">Stängt</span>
                </li>
                <span className="flex items-center gap-3 text-accent font-sans uppercase tracking-[0.2em] text-xs !font-bold ![margin:0px_0px_16px_1065px]">BESÖKSADRESS</span>
              </ul>
            </div>

            
            
            

            
            
            </div>
        </div>

        
        <div className="relative min-h-[500px] lg:min-h-full bg-mist overflow-hidden group">
          {}
          
          
          {}
          <div className="absolute inset-0 pointer-events-none" />
          <div className="absolute inset-0 pointer-events-none" />

          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
            {}
            
            {}
            
            
            {}
            
          </div>
        </div>
      </div>
    </section>;
}